<template>
 <cgs-modal :visible="vis" :title="userInfo.phone ? '修改手机号' : '绑定手机号'" @close="close"
  class="dmgm-base-component-pass-word-modal">
  <cgs-form :model="formState" ref="FromRef" :rules="rules">
   <cgs-form-item label="手机号" name="phone">
    <cgs-input v-model:value="formState.phone" placeholder="请输入手机号">
     <template #prefix>
      <div>+86</div>
     </template>
    </cgs-input>
   </cgs-form-item>

  </cgs-form>
  <template #footer>
   <cgs-button class="dmgm-base-component-pass-word-modal-btn-close" @click="close">关闭</cgs-button>
   <cgs-button class="dmgm-base-component-pass-word-modal-btn-ok" type="primary" @click="ok">确定</cgs-button>

  </template>
 </cgs-modal>

</template>

<script setup>
import { computed, reactive, ref, getCurrentInstance, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { changeUserInfo } from "@/api/user"
import { setUserAuthority } from "@/utils/author";
import { logout } from "@/api/user"



const props = defineProps({
 visible: {
  type: Boolean,
  default: false
 },
 title: {
  type: String,
  default: 'title'
 },
 userInfo: {
  type: Object,
  default: undefined
 }

})
const FromRef = ref(null)
const vis = computed(() => props.visible)

const { proxy } = getCurrentInstance()




const formState = reactive({
 phone: "",
})


const checkData = () => {

}

const rules = {
 phone: [
  {
   required: true, message: "手机号码格式错误，请重新确认", trigger: "blur", pattern: new RegExp(/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
   ),
  },
 ],

}





const emit = defineEmits(['close', "ok"])

const close = () => {
 emit('close')
}

const ok = async () => {
 let valid = await FromRef.value?.validateFields()
 if (valid) {
  let res = await changeUserInfo({
   userId: props.userInfo.userId,
   phone: formState.phone
  })
  if (res.code === 200) {
   props.userInfo.phone = formState.phone
   if (props.userInfo.phone) {
    proxy.$message.success("修改成功")
   } else {
    proxy.$message.success("绑定成功")
   }
   setUserAuthority(JSON.stringify(props.userInfo))
  }
  close()
 }
}
onMounted(() => {
 if (props.userInfo.phone) {
  formState.phone = props.userInfo.phone
 }
})

</script>

<style scoped>
.dmgm-base-component-pass-word {
 display: flex;
 flex-wrap: wrap;
 margin-bottom: 20px;
}

.select-sql-item {
 background: rgba(216, 216, 216, 0.4);
}

.dmgm-base-component-pass-word-item {
 width: 119px;
 height: 113px;
 display: flex;
 flex-direction: column;
 justify-content: center;
 align-items: center;
 border-radius: 10px;
 margin-right: 10px;
 padding: 10px 0 5px 0;
}

.dmgm-base-component-pass-word-item:hover {
 background: rgba(216, 216, 216, 0.4);
}

.dmgm-base-component-pass-word-item img {
 width: 100%;
 height: 100%;
}

.dmgm-base-component-pass-word-item span {
 font-size: 12px;
}
</style>

<style></style>